import React, { Component } from 'react';
import lang from '../../lang/index';
import vipListConfig from './vipcz-config'
import url from 'c-url';
import Tooltip from 'rc-tooltip';
// import vipChargeList from './vipcz-charge-config'
import NumberUtil from '../../lib/util/number';
import VipSvc from './vip.svc';

const maps = {
    mobile: 'Mobile',
    line: 'Line',
    weChat: 'WeChat',
    whatsApp: 'WhatsApp',
    facebook: 'Facebook',
    email: 'Email',
};

class VipView extends Component {

    constructor(props) {
       super(props);

        this.countryCode = url.query('adscountry') || UP.Global.getUser().countryCode;

        this.state = {
            vips: [],
            vipList: []
        }
    }

    componentDidMount() {
        let countryCode = this.countryCode;
        
        // 获取充值档
        VipSvc.fetchRechargeOptions(countryCode).then(data => {
            
            let list = data.resultResponse;
            // 降序
            list = list.sort((a, b)=>{
                return a.rechargeAmount - b.rechargeAmount
            });

            this.setState({
                vipList: data.resultResponse
            });
        }, err => {
            // error
        });

        // 获取客服
        VipSvc.fetchVipConfs(countryCode).then(data => {
            let hostList = data.resultResponse;
            
            if (hostList.length == 0) { 
                // 若无VIP客服，使用大陆的
                VipSvc.fetchVipConfs('CN').then(data => {
                    let hostList = data.resultResponse;
                    
                    hostList = this.shuffle(hostList);
                
                    this.setState({
                        vips: data.resultResponse
                    });
                })
            } else {
                hostList = this.shuffle(hostList);
                
                this.setState({
                    vips: data.resultResponse
                });
            }
        }, err => {
            // error
        });
    }
    
    shouldComponentUpdate(nextProps,nextState){
        return !UP.Global.isLoginPop;
    }

    newHref (value) {
        window.open(value);
    }

    shuffle(arr) {
        let i = arr.length;
        
        while (i) {
            let j = Math.floor(Math.random() * i--);
            [arr[j], arr[i]] = [arr[i], arr[j]];
        }

        return arr
    }

    render() {
        let countryCode = (this.countryCode != 'PK' && UP.Global.middelEastCountryCodes.indexOf(this.countryCode) > -1) ? 'MSL' : this.countryCode;
        let hostLists = vipListConfig[countryCode] || vipListConfig['CN'];

        let { vips, vipList } = this.state;

        if (vipList.length  > 0 ) {

            $vipRechargeList = (
                <div className="vip-chargelist hidden">
                    <div className="title">{lang.template('充值档位参考')}</div>
                    <ul className="chargelist">
                        {
                            vipList.map((item,index)=>(
                                <li key={index}>
                                    <div className="detail">
                                        <div className="value">
                                            <span className="num">{NumberUtil.separate(item.gearDrillNumber)}</span>
                                            <icon></icon>
                                        </div>
                                        <em className="tip">{item.currencySymbol}{NumberUtil.separate(item.rechargeAmount)}</em>
                                    </div>
                                    { item.addDrill > 0 ? <div className="price">{NumberUtil.separate(item.addDrill)}</div> : null }
                                </li>
                            ))
                        }
                    </ul>
                </div>
            )
        } else {
            $vipRechargeList= null
        }

        return (
    	    <div className="vip-box" ref="box">
                { 
                    ['CN', 'TW', 'MO', 'MYC', 'HK'].indexOf(countryCode)  > -1 ? (
                        <div className="vip-title">{lang.template('直接联系官方客服进行充值，选择档位越高，优惠力度越大。')}</div>
                    ) : null
                }
                { $vipRechargeList }
                <div className="vipcz-head">
                    <div className='border'></div>
                    <div className="text">{lang.template("官方充值客服")}</div>
                    <div className='border'></div>
                </div>
                <div className="vipcz-list clearfix" >
                    {
                        vips.map((item, key)=>{
                            const ser = {
                                ...item,
                                sns: JSON.parse(item.contactList)
                            };
                            
                            let $wechat, $wechatimg, $line, $lineimg, $whatsapp, $othertype;
                            let contact = [];

                            if (ser.sns.weChat) {
                                $wechatimg = (
                                    <div className="qrcode" ref={"weiimg"+key}>
                                        <i className='qrcode-bg' style={{backgroundImage:`url(`+ ser.sns.wechatqrcode +`)`}}></i>
                                    </div>
                                );
                                $wechat = (
                                    <Tooltip overlay={$wechatimg} placement="right" trigger={['hover']} getTooltipContainer={()=>this.refs.box} overlayClassName="recharge-tooltip-vip">
                                        <div className="chat-item wechat">{lang.template('微信')} : {ser.sns.weChat}</div>
                                    </Tooltip>
                                )
                                contact[contact.length] = $wechat;
                            }

                            if (ser.sns.line) {
                                $lineimg = (
                                    <div className="qrcode" ref={"lineimg"+key}>
                                        <i className='qrcode-bg' style={{backgroundImage:`url(` + ser.sns.lineqrcode + `)`}}></i>
                                    </div>
                                );

                                $line = (
                                    <Tooltip overlay={$lineimg} placement="right" trigger={['hover']} getTooltipContainer={()=>this.refs.box} overlayClassName="recharge-tooltip-vip">
                                        <div className="chat-item line">{lang.template('Line')} : {ser.sns.line}</div>
                                    </Tooltip>
                                )
                                contact[contact.length] = $line;
                            }
                            if (ser.sns.messenger) {
                                $messengerimg = (
                                    <div className="qrcode" ref={"messengerimg"+key}>
                                        <i className='qrcode-bg' style={{backgroundImage:`url(` + ser.sns.messengerqrcode + `)`}}></i>
                                    </div>
                                );

                                $messenger = (
                                    <Tooltip overlay={$messengerimg} placement="right" trigger={['hover']} getTooltipContainer={()=>this.refs.box} overlayClassName="recharge-tooltip-vip">
                                        <div className="chat-item messager"> {ser.sns.messenger}</div>
                                    </Tooltip>
                                )
                                contact[contact.length] = $messenger;
                            }
                            if (ser.sns.zalo) {
                                $zaloimg = (
                                    <div className="qrcode" ref={"zaloimg"+key}>
                                        <i className='qrcode-bg' style={{backgroundImage:`url(` + ser.sns.zaloqrcode + `)`}}></i>
                                    </div>
                                );

                                $zalo = (
                                    <Tooltip overlay={$zaloimg} placement="right" trigger={['hover']} getTooltipContainer={()=>this.refs.box} overlayClassName="recharge-tooltip-vip">
                                        <div className="chat-item zalo">{lang.template('Zalo')} : {ser.sns.zalo}</div>
                                    </Tooltip>
                                )
                                contact[contact.length] = $zalo;
                            }
                            
                            if (ser.sns.whatsApp){
                                $whatsapp = (
                                    <div className="chat-item whatsapp">{ser.sns.whatsApp}</div>
                                );
                                contact[contact.length] = $whatsapp;
                            } 

                            if (ser.sns.mobile){
                                contact[contact.length] = (
                                    <div className="chat-item  tel">{ser.sns.mobile}</div>
                                );
                            }

                            if (ser.sns.facebook ){
                                contact[contact.length] = (
                                    <div className="chat-item facebook" onClick={this.newHref.bind(this, ser.sns.facebook)}>{ser.sns.facebook}</div>
                                );
                            }  

                            if (ser.sns.email){
                                contact[contact.length] = (
                                    <a className="chat-item  email" href={`mailto: ${ser.sns.email}`}>{ser.sns.email}</a>
                                );
                            }  


                            if (contact.length < 3){
                                if(!ser.sns.line){
                                    contact[contact.length] = (
                                       <div className="chat-item  line line-no">{lang.template('Line')} : --</div>
                                    );
                                }

                                if (!ser.sns.mobile){
                                    contact[contact.length] = (
                                       <div className="chat-item  tel tel-no">--</div>
                                    );
                                }
                            }

                            return (
                                <div className="vip-item" key={key}>
                                    <div className="avatar">
                                        <img src={item.avatar}/>
                                    </div>
                                    <div className="content">
                                        <div className="nickname">{item.nickName}</div>
                                        { contact }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
    	);
    }
}

export default VipView;


// WEBPACK FOOTER //
// ./js/mall/recharge/vip.js